
angular.module("ainapp")
    .controller("ApprovalDebitNoteController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, window) {

            $scope.PageName = "Debit Note Approvals";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

             $scope.IsAdmin = false;
            if ($scope.TokenInfo.Role == "Admin" || $scope.TokenInfo.Role == "admin" || $scope.TokenInfo.Role == "SA" || $scope.TokenInfo.Role == "CA" || $scope.TokenInfo.Role == "0") {
                $scope.IsAdmin = true;
            }

            $scope.init = function () {
                $scope.filter = {
                    Keyword: "",
                };
            }
            $scope.init();


            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        MainService.DebitNoteForApprovals(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success(false);
                            toastr.error($scope.NetworkErrorLan);
                        })
                    }
                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },
                            VoucherNumber: {
                                type: "string",
                            },
                            SubAccounts: {
                                type: "string",
                            },

                            TotalDebit: {
                                type: "float",
                            },

                            TotalCredit: {
                                type: "float",
                            },
                            CalcGrandCreditTotal: {
                                type: "float",
                            },

                            CalcGrandDebitTotal: {
                                type: "float",
                            },
                            "Currency.Name": {
                                type: "string",
                            },
                            CreatedDate: {
                                type: "date",
                            },
                            "CreatedBy.UserName":{
                                type: "string",
                            }
                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                filterable: true,

                columns: [



                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.date}}",
                                            },
                    {
                        field: "VocherNumber",
                        title: "Voucher Number",
                        headerTemplate: "{{LanguageData.vouchernumber}}",
                        //                        template: "<div style='text-align: right'>#=kendo.toString(VocherNumber, 'n')#</div>",

                                            },
                    {
                        field: "SubAccounts",
                        title: "Accounts",
                     },

                    {
                        field: "TotalDebit",
                        title: "Total Debit",
                        headerTemplate: "{{LanguageData.totaldebit}}",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalDebit, 'n')#</div>",

                                            },
                    {
                        field: "TotalCredit",
                        title: "Total Credit",
                        headerTemplate: "{{LanguageData.totalcredit}}",
                        template: "<div style='text-align: right'>#=kendo.toString(TotalCredit, 'n')#</div>",

                                            },

                    {
                        field: "Currency.Name",
                        title: "Currency",
                        headerTemplate: "{{LanguageData.Currency}}",
                    },
                    {
                        field: "CalcGrandDebitTotal",
                        title: "Calc Total Debit",
                        template: "<div style='text-align: right'>#=kendo.toString(CalcGrandDebitTotal, 'n')#</div>",
                                            },
                    {
                        field: "CalcGrandCreditTotal",
                        title: "Calc Total Credit",
                        template: "<div style='text-align: right'>#=kendo.toString(CalcGrandCreditTotal, 'n')#</div>",
                                            },
                                            {
                                                field: "CreatedDate",
                                                template: "#= kendo.toString(kendo.parseDate(CreatedDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                                                title: "Created Date"
                                            },
                        
                                            {
                                                field: "CreatedBy.UserName",
                                                title: "Created By"
                                            },

                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template:`<div ng-include="'templates/common/approvalButtons.html'"></div>`,
                        width: '200px'
                        },


                                        ],
            };

            $scope.Edit = function (data) {
                $state.go("editDebitNote", {
                    VoucherId: data.Id
                })
            };


            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }

             $scope.Approve = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ApproveDebitNote(data.Id).then(function (response) {
                    if (response.data == "Success") {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning(response.data);
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.Resubmit = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.ResubmitDebitNote(data.Id).then(function (response) {
                    if (response.data == "Success") {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning(response.data);
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.RejectData = {
                VoucherId: "",
                Reason: "",
            };

            $scope.Reject = function (data) {
                $scope.RejectData = {
                    VoucherId: data.Id,
                    Reason: "",
                };

                $('#rejectModal').modal('show');
            }

            $scope.ConfirmReject = function () {

                if ($scope.RejectData.Reason == "") {
                    toastr.warning("Enter Reason");
                } else {
                    $scope.load = true;
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.RejectDebitNote($scope.RejectData).then(function (response) {
                        if (response.data == "Success") {
                            toastr.success("Success");
                            $scope.refresh();
                            $('#rejectModal').modal('hide');
                        } else {
                            toastr.warning(response.data);
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function () {
                        toastr.error("NetworkError");
                        $scope.working = false;
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    })
                }

            }

            $scope.View = function (data) {
                if (!$scope.PageAccessInfo.IsView) {
                    toastr.info($scope.LanguageData.YouDontHaveAccessToViewData);
                } else {
                    // $state.go("viewDebitNote", {
                    //     VoucherId: data.Id
                    // })

                    var url = $state.href('viewDebitNote', {
                        VoucherId: data.Id
                    });
                    window.open(url, '_blank');
                }
            }


                }])
